import { useState, useEffect, RefObject } from 'react';

type UseAutoCollapseProps = {
  containerRef: RefObject<HTMLDivElement>;
  isMobileLayout: boolean;
  dependencies: any[];
};

export const useAutoCollapse = ({
  containerRef,
  isMobileLayout,
  dependencies,
}: UseAutoCollapseProps) => {
  const [shouldCollapse, setShouldCollapse] = useState(isMobileLayout);

  useEffect(() => {
    if (isMobileLayout) return;

    const observer = new ResizeObserver(() => {
      if (!containerRef.current) return;
      const container = containerRef.current;

      const socialContainer = container.querySelector(
        '.header-accessibility__social',
      ) as HTMLElement;

      const measurerNode = container.querySelector(
        '.header-accessibility__actions-measurer',
      ) as HTMLElement;

      if (socialContainer && measurerNode) {
        // Add a gap of 24px (1.5rem) to ensure we have breathing room
        const totalWidthNeeded =
          socialContainer.scrollWidth + measurerNode.scrollWidth + 24;

        if (totalWidthNeeded > container.clientWidth) {
          setShouldCollapse(true);
        } else {
          setShouldCollapse(false);
        }
      }
    });

    if (containerRef.current) {
      observer.observe(containerRef.current);

      const socialContainer = containerRef.current.querySelector(
        '.header-accessibility__social',
      );
      if (socialContainer) observer.observe(socialContainer);

      const measurerNode = containerRef.current.querySelector(
        '.header-accessibility__actions-measurer',
      );
      if (measurerNode) observer.observe(measurerNode);
    }

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMobileLayout, ...dependencies]);

  return { shouldCollapse };
};
